// extracted by mini-css-extract-plugin
export default {"container":"update_application_container__n0vYI","product_toggle_lists":"update_application_product_toggle_lists__4Y5UJ","product_item":"update_application_product_item__docz6"};